module.exports = __webpack_public_path__ + "img/homeRightImg.1aa2506.png";